import FinancialBtn from '../../Components/Buttons/Categories/FinancialBtn/Financialbtn';
import GeneralBtn from '../../Components/Buttons/Categories/GeneralBtn/GeneralBtn';
import SportBtn from '../../Components/Buttons/Categories/SportBtn/SportBtn';
import NextBtn from '../../Components/Buttons/NextBtn/NextBtn';
import Header from '../../Components/Header/Header';
import './Select.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import NewsOne from '../../assets/image/General news logo_0.png';
import NewsTwo from '../../assets/image/General news logo.png';
import NewsThree from '../../assets/image/General news logo (2).png';
import SportOne from '../../assets/image/logo sport.png';
import SportTwo from '../../assets/image/logo sport (1).png';
import FinOne from '../../assets/image/logo finance (3).png';
import FinTwo from '../../assets/image/logo finance (1).png';
import FinThree from '../../assets/image/logo finance (2).png';
import SportThree from '../../assets/image/logo sport (4).png';
import SportFour from '../../assets/image/logo sport (2).png';
import Footer from '../../Components/Footer/Footer';

const Select = () => {
    return ( 
        
            <div className="select-all">
                <div className="head">
                <Header />
                </div>

            <div className="select">
                <h1>Select your <br />news</h1>
            <div className="select-content">
            {/* <div className="select-button">
                <h5>Categories: </h5>
                <GeneralBtn />
                <FinancialBtn />
                <SportBtn />
            </div> */}

            <div className="news">
                <img src={NewsOne} alt="news" />
                <img src={NewsTwo} alt="news" />
                <img src={NewsThree} alt="news" />
                <img src={SportOne} alt="sport" />
                <img src={SportTwo} alt="sport" />
                <img src={FinOne} alt="finance" />
                <img src={FinTwo} alt="finance" />
                <img src={FinThree} alt="finance" />
                <img src={SportThree} alt="sport" />
                <img src={SportFour} alt="sport" />
            </div>

            <nav className="d-flex justify-content-center align-items-center">
                <ul className="pagination pagination-sm">
                    <li className="page-item" aria-current="page">&bull;
                    </li>
                    <li className="page-item">&bull;</li>
                    <li className="page-item">&bull;</li>
                </ul>
            </nav>

            <div className="next">
                <NextBtn />
            </div>
            </div>
          </div>
          <footer>
              <Footer />
          </footer>
        </div>
     );
}
 
export default Select;